import React, { FC, useState } from 'react'
import ContentModal from '../molecules/ContentModal/ContentModal'
import { Widget } from '@typeform/embed-react'
//@ts-ignore-next-line
import X from '../../images/blackx.svg'

export interface Props {
  isFilterWizardModalVisible: boolean
  onClose: () => unknown
}

const FilterWizardModal: FC<Props> = ({
  isFilterWizardModalVisible,
  onClose
}) => {
  return (
    <ContentModal
      onClose={onClose}
      isOpen={isFilterWizardModalVisible}
      useCustomHeader
      childWrapperStyle="!px-0 !py-0 !sm:p-0 sm:!pb-6 md:max-h-[90vh]"
      childContainerStyle="sm:ml-0 w-full !mt-0"
      bodyContainerStyle="!max-w-[642px]"
    >
      <div className="relative">
        <div>
          <img
            src={X}
            alt="close"
            className="absolute right-4 top-4 z-40 size-4 cursor-pointer"
            onClick={onClose}
          />
        </div>
        <Widget
          id="mz3cyxT4"
          inlineOnMobile
          style={{ width: '100%', height: '700px' }}
        />
      </div>
    </ContentModal>
  )
}

export default FilterWizardModal
